import { useState } from "react";
import { Flame, Loader2, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { createPromoCheckout } from "@/lib/api";

// Promo auto-hides itself after this date (local time).
export const PROMO_END = new Date("2026-10-31T23:59:59");
export const isPromoActive = () => new Date() <= PROMO_END;

export default function AnnouncementBar() {
  const [loading, setLoading] = useState(false);

  const claim = async () => {
    try {
      setLoading(true);
      const data = await createPromoCheckout({ origin_url: window.location.origin });
      if (data?.url) {
        window.location.href = data.url;
      } else {
        toast.error("Could not start checkout. Please try again.");
      }
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Checkout failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="promo-announcement-bar"
      className="fixed top-0 left-0 right-0 z-[60] bg-[#CCFF00] text-black"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-12 h-10 flex items-center justify-center gap-2 md:gap-3">
        <Flame className="w-4 h-4 shrink-0 hidden sm:block" />
        <p className="text-[11px] sm:text-xs md:text-sm font-semibold truncate text-center">
          <span className="font-black">$499</span>
          <span className="hidden sm:inline"> ENTIRE WEBSITE BUILD</span>
          <span className="sm:hidden"> Website Build</span>
          <span className="hidden md:inline"> · 1-yr hosting included</span>
          {" · "}
          <span className="font-black">ends Oct 31</span>
        </p>
        <button
          data-testid="promo-claim-btn"
          onClick={claim}
          disabled={loading}
          className="shrink-0 inline-flex items-center gap-1 bg-black text-[#CCFF00] px-3 py-1 rounded-full text-[10px] md:text-[11px] font-bold uppercase tracking-wide hover:opacity-80 transition-opacity disabled:opacity-60"
        >
          {loading ? (
            <Loader2 className="w-3.5 h-3.5 animate-spin" />
          ) : (
            <>
              Claim <ArrowRight className="w-3 h-3" />
            </>
          )}
        </button>
      </div>
    </div>
  );
}
